var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.sectionRef,class:[
        'block mx-auto bg-white   shadow-lg page',
        {
            'w-a4w h-a4h': _vm.isPortraitMode,
            'h-a4w w-a4h ': !_vm.isPortraitMode
        }
    ]},[(_vm.title)?_c('h2',{staticClass:"block mb-5 text-xl font-semibold text-right text-output-primary pt-output px-output"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(!_vm.noPadding)?_c('div',{ref:"content",class:[
            'relative w-full pb-output  px-output',
            {
                'h-full': _vm.fullHeight
            }
        ]},[_vm._t("default")],2):_vm._e(),_c('div',{class:[
            'relative w-full',
            {
                'h-full': _vm.fullHeight
            }
        ]},[_vm._t("noPadding")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }